import React, { useEffect, useState } from "react";
import { Popup } from 'react-map-gl';
import PopUpInfo from "../PopUpInfo/PopUpInfo";
import "./PopUpList.css";
import { searchRollList, searchCoords } from "../../../../redux/actions/nbhd/search";
import { CoordsResponse } from "../../../../redux/reducers/getNBHDReducer/getCoordsReducer";
import { RollListResponse } from "../../../../redux/reducers/getNBHDReducer/getRollListReducer";
import { RootState } from "../../../../redux/reducers/root";
import { useDispatch, useSelector } from "react-redux";
import { getRollFromCentroid } from '../../../../utils/getRollFromCentroid';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import AmpLoadingSpinner from "../../../common/AmpLoadingSpinner/AmpLoadingSpinner";
import extractFormData from "../../../../utils/extractFormData";

interface PopUpListProps {
    coords: Array<number>;
    snaps: Array<Record<string, unknown>>;
}

export default function PopUpList(props: PopUpListProps) {
    const dispatch = useDispatch();
    const Coords = useSelector((state: RootState) => state.NBHDReducer.Coords as CoordsResponse);
    const RollList = useSelector((state: RootState) => state.NBHDReducer.RollList as RollListResponse);
    const [popupInfo, setPopupInfo] = useState<Record<string, unknown> | null>(null);
    const [currentSnapshotRoll, setCurrentSnapRoll] = useState("");
    const [searchCoordsResults, setsearchCoordsResults] = useState<Record<string, unknown> | null>(null);
    const [searchRollListResults, setsearchRollListResults] = useState<Array<string>>([]);
    const [loaded, setLoaded] = useState(false);
    const [loadedList, setLoadedList] = useState(false);
    const [showList, setShowList] = useState<Array<string>>([]);
    const coordsObj = { lnglat: { lng: props.coords[1], lat: props.coords[0] } };
    useEffect(() => {
        // call searchCoords once when PopUpList is called
        getRollFromCentroid(props.coords[0], props.coords[1]).then(roll => {
            const rollList = roll.split(",");
            if (searchCoordsResults == null) {
                dispatch(searchCoords(rollList[1].substring(0, 15)));
                setLoaded(true);
            }
        });
        // eslint-disable-next-line      
    }, [])
    useEffect(() => {
        // when searchCoords has result place data in searchCoordsResults
        if (loaded) {
            if (!Coords.loading && Coords.results) {
                if (searchCoordsResults === null) {
                    setsearchCoordsResults(Coords.results);
                }
            }
        }

        // eslint-disable-next-line
    }, [Coords])

    useEffect(() => {
        // after getting the coords data now call getRollList function using the lat and lon
        if (loaded) {
            if (searchCoordsResults) {
                if (Number(searchCoordsResults["lat"])) {
                    dispatch(searchRollList(Number(searchCoordsResults["lat"]), Number(searchCoordsResults["lon"])));
                    setLoadedList(true);
                }
                setsearchCoordsResults(null);
            }
        }

        // eslint-disable-next-line
    }, [searchCoordsResults])


    useEffect(() => {
        // when searchCoords has result place data in searchCoordsResults
        if (loadedList) {
            if (!RollList.loading && RollList.results) {
                if (searchRollListResults.length === 0) {
                    const PopupHandle = document.getElementsByClassName("mapboxgl-popup-content")[0];
                    const PopupMarkerHandle = document.getElementsByClassName("mapboxgl-popup-tip")[0];
                    if (RollList.results.length === 1) {
                        setCurrentSnapRoll(RollList.results[0][0]);
                        setPopupInfo(coordsObj);
                        PopupHandle.className += " hidden";
                        PopupMarkerHandle.className += " hidden";
                    } else {
                        setsearchRollListResults(RollList.results);
                        PopupHandle.className += " show";
                        PopupMarkerHandle.className += " show";
                    }
                    
                }
            }
        }
        // eslint-disable-next-line
    }, [RollList])


    useEffect(() => {
        if (loadedList) {
            if (searchRollListResults.length !== 0) {
                setShowList(searchRollListResults);
                // setsearchRollListResults([]);
            }
        }

        // eslint-disable-next-line
    }, [searchRollListResults])


    const selectPropertyNumber = (data) => {
        const propertyData = data;
        setCurrentSnapRoll(propertyData.data[0]);
        setPopupInfo(coordsObj);
    };

    const MultiplePopupButton = (data) => {
        return (
            <button className="buttonRoll" onClick={() => { selectPropertyNumber(data) }}>{data.data[1]}</button>
        );
    };


    const listAddresses = () => {
        // show full list of address
        if (showList[0] === "NULL") {
            return (
                <h3 className="nullFound">No Address Found</h3>
            )
        }
        return (
            <AmpLoadingSpinner loading={Coords.loading}>
                <AmpLoadingSpinner loading={RollList.loading}>
                    <div className="rollListContainer">
                        {showList.map(
                            (data, idx) =>
                                <div key={idx} className="singleRoll">
                                    <MultiplePopupButton data={data} />
                                </div>
                        )}
                    </div>
                </AmpLoadingSpinner>
            </AmpLoadingSpinner>
        );

    };

    const filterAddresses = (text: string) => {
        // show searched addresses only
        // const text = document.getElementById("roomNumSearch").value;

        if (text) {
            const filterResult = searchRollListResults.filter((value) => {
                try {
                    if (value[2].includes(text)) {
                        return value;
                    }
                } catch (error) {
                    console.error(error)
                }
                return false;
            });
            
            if (filterResult.length === 0) {
                setShowList(["NULL"]);
            } else {
                setShowList(filterResult);
            }

        } else {
            setShowList(searchRollListResults);
        }
    };

    const searchHandler = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const data = extractFormData(e);
        filterAddresses(data["room"] as string);
    };

    return (<>
        <div>
            {showList && (
                <div>
                    <h4 className="title">Multiple Points Found</h4>
                    <h3 className="roomSearch">
                        <form onSubmit={(e) => {searchHandler(e)}}>
                            <span>
                                Search Unit Number: &emsp;
                                <input className="roomNumSearch" name="room" type="text" id="roomNumSearch" ></input>
                                <button type="submit" className="roomNumButton" id="roomNumButton"><FontAwesomeIcon className="search-font-awesome-icon" icon={faMagnifyingGlass} /></button>
                            </span>
                        </form>
                    </h3>
                    <div className="instruction">
                        Select Address:
                    </div>
                    <div id="addressList">
                        {listAddresses()}
                    </div>
                </div>
            )}
            {popupInfo && (
                <Popup
                    anchor="left"
                    longitude={props.coords[1]}
                    latitude={props.coords[0]}
                    onClose={() => { setPopupInfo(null); setCurrentSnapRoll("") }}
                    className='popupcard'
                ><PopUpInfo coords={[props.coords[0], props.coords[1]]} snapRoll={currentSnapshotRoll} snapList={props.snaps} /></Popup>)}
        </div>
    </>

    );
}